module.exports = __webpack_public_path__ + "img/proyecto_7_mv.cc6cfa7e.webp";